﻿import intlTelInput from 'intl-tel-input';
import utils from 'intl-tel-input/build/js/utils';

document.addEventListener('alpine:init', () => {
	Alpine.data('individualForm', () => ({
		init() {
			const input = this.$refs.contactpersoonTelefoonNummer;
			intlTelInput(input, {
				utilsScript: utils,
				autoInsertDialCode: true,
				nationalMode: false,
				separateDialCode: true,
				preferredCountries: ['be'],
				hiddenInput: input.name,
				initialCountry: input.value !== '' ? undefined : 'BE'
			});
			input.name = ''; // intlTelInput generates a new (hidden) input with the same name. 
		},
	}))
});